
export default function ProblemStatement() {
  const challenges = [
    {
      icon: 'ri-stack-line',
      title: 'Fragmented Systems',
      description: 'Construction teams were managing Health & Safety, Asset Management, Quality Management, Document Control, Incident Reporting, Template Management, and Form Builders across seven separate platforms.',
      color: '#F16051'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Compliance Complexity',
      description: 'Australian construction regulations require strict documentation, audit trails, and role-based access controls. Existing tools lacked the granularity needed for enterprise-level compliance.',
      color: '#182423'
    },
    {
      icon: 'ri-brain-line',
      title: 'Cognitive Overload',
      description: 'Site workers, engineers, and managers were required to learn and navigate multiple interfaces daily. Context-switching between systems reduced productivity significantly.',
      color: '#F16051'
    },
    {
      icon: 'ri-expand-diagonal-line',
      title: 'Scalability Limitations',
      description: 'As organizations grew, managing permissions, templates, and workflows across disconnected systems became unsustainable with no centralized control.',
      color: '#182423'
    }
  ];

  return (
    <section className="py-20" style={{ background: 'linear-gradient(180deg, #FEF7F6 0%, #FFFFFF 100%)' }}>
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 rounded-full text-sm font-semibold mb-4" style={{ backgroundColor: '#F16051', color: 'white' }}>
            The Challenge
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#182423' }}>
            Problem Statement
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Understanding the core business challenges that drove the need for a unified platform
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {challenges.map((challenge, index) => (
            <div 
              key={index} 
              className="group relative bg-white rounded-3xl p-8 border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-32 h-32 rounded-full opacity-10 -translate-y-1/2 translate-x-1/2" style={{ backgroundColor: challenge.color }}></div>
              
              <div className="relative z-10">
                <div 
                  className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300"
                  style={{ backgroundColor: challenge.color }}
                >
                  <i className={`${challenge.icon} text-white text-2xl`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">{challenge.title}</h3>
                <p className="text-gray-600 leading-relaxed">{challenge.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
